import { ChevronRightIcon } from '@heroicons/react/20/solid';

type BreadcrumbLinkProps = {
  label: string | null | undefined;
  href?: string;
};

export function BreadcrumbLink({ label, href }: BreadcrumbLinkProps) {
  const baseClassName = 'shrink-0 whitespace-nowrap text-neutral-300';

  if (!href) {
    return <span className={baseClassName}>{label ?? '—'}</span>;
  }

  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className={`${baseClassName} hover:text-white`}
    >
      {label ?? '—'}
    </a>
  );
}

export function Separator() {
  return <ChevronRightIcon className='h-3.5 w-3.5 shrink-0 text-neutral-500' />;
}
